/**
 * Connection configuration interfaces and defaults
 */
export const DEFAULT_CONNECTION_CONFIG = {
    // Timeouts
    connectionTimeout: 30000, // 30 seconds
    iceGatheringTimeout: 10000, // 10 seconds
    // Reconnection
    reconnectEnabled: true,
    maxReconnectAttempts: 5, // 5 attempts before giving up
    reconnectBackoffBase: 1000, // Start with 1 second
    reconnectBackoffMax: 30000, // Cap at 30 seconds
    reconnectJitter: 0.1, // 10% jitter
    // Message buffering
    bufferEnabled: true,
    maxBufferSize: 100, // 100 messages
    maxBufferAge: 60000, // 1 minute
    preserveBufferOnClose: false, // Clear buffer on close
    // ICE polling
    icePollingInterval: 500, // Poll every 500ms
    icePollingTimeout: 30000, // Stop polling after 30s
    // Debug
    debug: false,
};
/**
 * Merge user config with defaults.
 * @internal
 */
export function mergeConnectionConfig(userConfig) {
    return {
        ...DEFAULT_CONNECTION_CONFIG,
        ...userConfig,
    };
}
/**
 * Convert simplified ConnectionOptions to full ConnectionConfig.
 * Maps user-friendly names to internal config.
 */
export function toConnectionConfig(options) {
    if (!options)
        return DEFAULT_CONNECTION_CONFIG;
    return {
        ...DEFAULT_CONNECTION_CONFIG,
        ...(options.timeout !== undefined && { connectionTimeout: options.timeout }),
        ...(options.reconnect !== undefined && { reconnectEnabled: options.reconnect }),
        ...(options.maxReconnects !== undefined && { maxReconnectAttempts: options.maxReconnects }),
        ...(options.bufferMessages !== undefined && { bufferEnabled: options.bufferMessages }),
        ...(options.debug !== undefined && { debug: options.debug }),
    };
}
